import * as React from 'react';
import { Row, Col, Container } from 'reactstrap';
import {
    TreeList, orderBy, filterBy, mapTree, extendDataItem, treeToFlat, modifySubItems, createDataTree, getItemPath,
    TreeListTextFilter, TreeListNumericFilter, TreeListDateFilter, TreeListBooleanFilter, TreeListToolbar, TreeListCell, TreeListTextEditor, TreeListDraggableRow, removeItems, moveTreeItem, TreeListCellProps
} from '@progress/kendo-react-treelist';
import { Input } from '@progress/kendo-react-inputs';
import { TreeView, TreeViewDragClue, TreeViewDragAnalyzer, moveTreeViewItem } from '@progress/kendo-react-treeview';
import { Division } from '../../models/Division';
import { EmProduct } from '../../models/EmProduct';
/*import { divisions, products, attributes, codes } from '../../services/dummyData';*/
import { Code } from '../../models/Code';
import { FilterDescriptor } from '@progress/kendo-data-query';
import DivisionService from '../../services/DivisionService';
import EmProductService from '../../services/EmProductService';
import ProductService from '../../services/ProductService';
import { debug } from 'console';
import { codes } from '../../services/dummyData';
import CodeService from '../../services/CodeService';

import { Product } from '../../models/Product';
import { v4 as uuidv4 } from 'uuid';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { TreeListDraggableRowCustom } from '../controls/TreeList/TreeListDraggableRowCustom';
import { provideIntlService } from '@progress/kendo-react-intl';
import classNames from 'classnames';

const subItemsField = 'subItems';
const expandField = 'expanded';
const selectedField = 'selected';
const editField = 'inEdit';
const saveField = 'isSaving';

type ProductBuilderState = {
    emItems: TreeItem[];
    items: TreeItem[];
    itemsSort: any[];
    sortOnRecalc: boolean;
    filteredEmItems: TreeItem[];
    filteredItems: TreeItem[];
    emFilter: FilterDescriptor[];
    filter: FilterDescriptor[];
    prevEmFilter: FilterDescriptor[];
    prevFilter: FilterDescriptor[];
    flatEmItems: TreeItem[];
    flatItems: TreeItem[];
    expandedEmIds: string[];
    expandedIds: string[];
    selectedEmId: string;
    selectedId: string;
    selectedEmItem: TreeItem;
    selectedItem: TreeItem;
    selectedEmFullName: string;
    selectedFullName: string;
    itemsInEdit: TreeItem[];
    itemsInSave: TreeItem[];
    itemToDelete: TreeItem;
    dialogConfirmDeleteVisible: boolean;
    dragFrom: 'emproducts' | 'products';
    dragDataItem: TreeItem;
    dragDataItemLevel: number[];
    draggedOverItem: TreeItem;
    draggedOverItemLevel: number[];
};

const RowRender = (properties: {
    row, props, onDrop?, onDragStart, onDragOver?,
    canStartDrag: boolean,
    dropEffect: string;
}) => {
    const { row, props, onDrop, onDragStart, onDragOver, canStartDrag } = { ...properties }

    const additionalProps = {
        onDragStart: (e) => { if (canStartDrag) onDragStart(e, props.dataItem) },
        onDragOver: (e) => {
            //return false;
            if (onDragOver)
                onDragOver(e);
            //e.persist();
            //console.log('onDragOver', e, props.dataItem);

            //e.dataTransfer.setData('text', (props.dataItem as TreeItem).Id);
            e.preventDefault();
            e.dataTransfer.dropEffect = properties.dropEffect;
        },
        onDrop: (e) => {
            if (onDrop)
                onDrop(e)
        },
        draggable: canStartDrag
    };
    return React.cloneElement(row, { ...row.props, ...additionalProps }, row.props.children)
}


class ProductBuilder extends React.Component<{}, ProductBuilderState> {

    constructor(props: any) {
        super(props);

        //let data = divisions.map(x => TreeItem.fromDivision(x));
        //let flatData = treeToFlat(data, expandField, subItemsField) as TreeItem[];

        this.state = {
            emItems: [],
            items: [],
            itemsSort: [{
                field: "Name", dir: "asc"
            }],
            sortOnRecalc: true,
            filteredEmItems: [],
            filteredItems: [],
            flatEmItems: [],
            flatItems: [],
            emFilter: [],
            filter: [],
            prevEmFilter: [],
            prevFilter: [],
            expandedEmIds: [],
            expandedIds: [],
            selectedEmId: undefined,
            selectedId: undefined,
            selectedEmItem: undefined,
            selectedItem: undefined,
            selectedEmFullName: undefined,
            selectedFullName: undefined,
            itemsInEdit: [],
            itemsInSave: [],
            itemToDelete: undefined,
            dialogConfirmDeleteVisible: false,
            // drag
            dragFrom: undefined,
            dragDataItem: undefined,
            dragDataItemLevel: undefined,
            draggedOverItem: undefined,
            draggedOverItemLevel: undefined
        };
    }

    componentDidMount() {
        this.loadAllEmProducts();
        this.loadAllProducts();
    }

    loadAllEmProducts = async () => {

        const divisionsResult = await DivisionService.list();
        const emProductsResult = await EmProductService.list();


        if (!divisionsResult.hasErrors && !emProductsResult.hasErrors) {

            // original data
            const divisionTreeItems = divisionsResult.value.map(x => TreeItem.fromDivision(x, emProductsResult.value)).sort(SortTreeItem);
            //const flatEmItems = treeToFlat(divisionTreeItems, expandField, subItemsField) as TreeItem[];

            this.setState({
                emItems: divisionTreeItems,

            }, () => {
                this.recalcFilteredEmItems();
            });

        } else {
            console.error('loadAllEmProducts: tree data not loaded');
        }
    }

    loadAllProducts = async () => {
        const productsResult = await ProductService.list();

        if (!productsResult.hasErrors) {
            // products
            const flatItems = productsResult.value.map(x => TreeItem.fromProduct(x));

            const productTreeItems = createDataTree(flatItems, (x: TreeItem) => x.Id, (x: TreeItem) => x.ParentId, subItemsField);

            this.setState({
                items: productTreeItems
            }, () => {
                this.recalcFilteredItems()
            });
        } else {
            console.error('loadAllProducts: tree data not loaded');
            localStorage.removeItem("azure_ad_token");
            localStorage.removeItem("current_user");
        }
    }


    recalcFilteredEmItems = () => {

        var data = mapTree(this.state.emItems, subItemsField, (item: TreeItem) =>
            extendDataItem(item, subItemsField, {
                [expandField]: this.state.expandedEmIds.indexOf(item.Id) > -1,
                [selectedField]: this.state.selectedEmId == item.Id
            }));

        let filteredItems = filterBy(data, this.state.emFilter, subItemsField);

        //console.log('recalcFilteredEmItems, data, filtereds', data, filteredItems);
        let hasFilter = this.state.emFilter.length > 0 && this.state.emFilter[0].value.length > 1;

        let doExpand = hasFilter && this.state.prevEmFilter != this.state.emFilter;


        let infoData = doExpand
            ? this.expandAsDeepAsPosible(filteredItems, []/* this.state.expanded*/, filteredItems.length > 0 ? filteredItems[0] : undefined)
            : {
                expandedIds: this.state.expandedEmIds,
                selectedItem: this.state.selectedEmItem
            };

        filteredItems = mapTree(filteredItems, subItemsField, (item: TreeItem) =>
            extendDataItem(item, subItemsField, {
                [expandField]: infoData.expandedIds.indexOf(item.Id) > -1,
                [selectedField]: this.state.selectedEmId == item.Id
            }));

        this.setState({
            filteredEmItems: filteredItems,
            expandedEmIds: infoData.expandedIds,
            prevEmFilter: this.state.emFilter
        });
    }

    recalcFilteredItems = () => {

        let sortOnRecalc = this.state.sortOnRecalc;
        let items = this.state.items;
        if (sortOnRecalc) {

            items = orderBy(items, this.state.itemsSort, subItemsField);
            sortOnRecalc = false;
        }


        var data = mapTree(items, subItemsField, (item: TreeItem) =>
            extendDataItem(item, subItemsField, {
                [expandField]: this.state.expandedIds.indexOf(item.Id) > -1,
                [selectedField]: this.state.selectedId == item.Id
            }));

        let filteredItems = filterBy(data, this.state.filter, subItemsField);
        let hasFilter = this.state.filter.length > 0 && this.state.filter[0].value.length > 1;

        let doExpand = hasFilter && this.state.prevFilter != this.state.filter;


        let infoData = doExpand
            ? this.expandAsDeepAsPosible(filteredItems, []/* this.state.expanded*/, filteredItems.length > 0 ? filteredItems[0] : undefined)
            : {
                expandedIds: this.state.expandedIds,
                selectedItem: this.state.selectedItem
            };

        filteredItems = mapTree(filteredItems, subItemsField, (item: TreeItem) =>
            extendDataItem(item, subItemsField, {
                [expandField]: infoData.expandedIds.indexOf(item.Id) > -1,
                [selectedField]: this.state.selectedId == item.Id,
                [editField]: Boolean(this.state.itemsInEdit.find(i => i.Id === item.Id)),
                [saveField]: Boolean(this.state.itemsInSave.find(i => i.Id === item.Id))
            }));


        //console.log('filteredItems', filteredItems);

        // apply sort only if no editing
        //if ((this.state.itemsInEdit || []).length == 0)
        //    filteredItems = orderBy(filteredItems, this.state.itemsSort, subItemsField);

        /*filteredItems = filteredItems.sort(SortTreeItem);
        filteredItems = modifySubItems(filteredItems,
            subItemsField,
            (item: TreeItem) => item.expanded,
            (subitems: TreeItem[]) => subitems ? subitems.sort(SortTreeItem) : subitems);*/

        // set state
        this.setState({
            sortOnRecalc,
            items,
            filteredItems: filteredItems,
            expandedIds: infoData.expandedIds,
            prevFilter: this.state.filter
        });
    }

    expandAsDeepAsPosible = (items: TreeItem[], expandedIds: string[], selectedItem: TreeItem) => {

        expandedIds = expandedIds || [];

        if (items && items.length > 0) {

            if (expandedIds.indexOf(items[0].Id) < 0)
                expandedIds.push(items[0].Id);

            return this.expandAsDeepAsPosible(items[0].subItems, expandedIds, items[0]);
        }

        return { expandedIds, selectedItem };
    }

    buildFullName = (item: TreeItem) => {

        //console.log('buildFullName', item);
        //debugger;

        var result = [];
        var currentItem = item;
        let fullName = '';

        //const flatItems = treeToFlat(this.state.items, expandField, subItemsField) as TreeItem[];

        if (item) {

            do {
                result.push(currentItem);

                fullName = currentItem.Name + (fullName.length > 0 ? ' / ' : '') + fullName;

                currentItem = currentItem.parentDataItem;


            } while (currentItem);
        }

        return fullName;
    }

    addItem = () => {

        var newProduct: Product = {
            Description: '',
            ProductId: uuidv4(),
            EmProductId: undefined,
            ParentProductId: undefined
        }

        const newProductTreeItem: TreeItem = TreeItem.fromProduct(newProduct);
        newProductTreeItem.inEdit = true;
        newProductTreeItem.isNew = true;

        this.setState({
            items: [newProductTreeItem, ...this.state.items],
            itemsInEdit: [...this.state.itemsInEdit, { ...newProductTreeItem }]
        }, this.recalcFilteredItems)
    }

    enterEdit = (dataItem: TreeItem) => {
        //console.log('enterEdit:', dataItem);
        this.setState({
            itemsInEdit: [...this.state.itemsInEdit, extendDataItem(dataItem, subItemsField)]
        }, this.recalcFilteredItems);
    }

    remove = async (dataItem: TreeItem) => {
        this.setState({
            itemToDelete: dataItem,
            dialogConfirmDeleteVisible: true
        })
    }

    removeExecute = async (dataItem: TreeItem) => {

        const result = await ProductService.delete(dataItem.Id);
        if (!result.hasErrors) {
            this.setState({
                items: removeItems(this.state.items, subItemsField, x => x.Id === dataItem.Id),
                itemToDelete: undefined,
                dialogConfirmDeleteVisible: false
            }, this.recalcFilteredItems);
        } else {
            console.error('remove failed!', result);
        }
    }

    cancelConfirmDeleteDialog = () => {
        this.setState({
            itemToDelete: undefined,
            dialogConfirmDeleteVisible: false
        })
    }

    save = async (dataItem: TreeItem) => {
        console.log('save:', dataItem);

        dataItem = TreeItem.bindDescriptionToDataItem(dataItem);

        const saveResult = dataItem.isNew
            ? await ProductService.add(dataItem.dataItem as Product)
            : await ProductService.update(dataItem.dataItem as Product);

        if (!saveResult.hasErrors) {

            const itemsInEdit = this.state.itemsInEdit.filter(x => x.Id != dataItem.Id);

            this.setState({
                items: this.state.items.map(x => {

                    if (x.Id == dataItem.Id) {
                        x.isNew = false
                    }

                    return x;
                }),
                itemsInEdit: itemsInEdit,   // turn edit off for this item,
                sortOnRecalc: itemsInEdit.length == 0
            }, this.recalcFilteredItems);
        } else {
            console.error('saveResult failed!', saveResult);
        }
    }

    cancel = (dataItem: TreeItem) => {
        console.log('cancel:', dataItem);

        if (dataItem.isNew) {
            this.setState({
                // remove from items
                items: removeItems(this.state.items, subItemsField, x => x.Id === dataItem.Id),
                // remove from edit
                itemsInEdit: this.state.itemsInEdit.filter(x => x.Id != dataItem.Id)
            }, this.recalcFilteredItems);
        } else {

            this.setState({
                // reset initial value
                items: this.state.items.map(x => x.Id == dataItem.Id ? TreeItem.bindDataItemToDescription(x) : x),
                // remove from edit
                itemsInEdit: this.state.itemsInEdit.filter(x => x.Id != dataItem.Id)
            }, this.recalcFilteredItems);

        }
    }

    addChild = (dataItem: TreeItem) => {
        //console.log('addChild:', dataItem);
        var newProduct: Product = {
            Description: '',
            ProductId: uuidv4(),
            EmProductId: undefined,
            ParentProductId: dataItem.Id
        }

        const newProductTreeItem: TreeItem = TreeItem.fromProduct(newProduct);
        newProductTreeItem.inEdit = true;
        newProductTreeItem.isNew = true;

        this.setState({
            //items: [newProductTreeItem, ...this.state.items],
            expandedIds: [...this.state.expandedIds, dataItem.Id],
            itemsInEdit: [...this.state.itemsInEdit, { ...newProductTreeItem }],
            items: modifySubItems(this.state.items, subItemsField,
                (item: TreeItem) => item.Id === dataItem.Id,
                subItems => [newProductTreeItem, ...subItems]
            )

        }, this.recalcFilteredItems)
    }

    /*
    onRowDrop = async (event) => {
        console.log('rowdrop', event);


        const draggedItem = event.draggedItem as TreeItem;
        var productToSave = draggedItem.dataItem as Product;

        if (event.draggedOver) {
            const itemsPath = getItemPath(this.state.filteredItems, event.draggedOver, subItemsField) as TreeItem[];
            const destinationItem = itemsPath.pop();
            productToSave.ParentProductId = (destinationItem.dataItem as Product).ProductId;
        } else {
            productToSave.ParentProductId = undefined;
        }

        const saveResult = await ProductService.update(productToSave);

        if (!saveResult.hasErrors) {
            this.setState({
                items: moveTreeItem(this.state.items, event.dragged, event.draggedOver, subItemsField)
            }, this.recalcFilteredItems);
        }
    }*/

    CommandCell = ProductItemCommandCell(this.enterEdit, this.remove, this.save, this.cancel, this.addChild, editField)

    handleDragStartFirst = (e, dataItem: TreeItem) => {
        this.setState({
            dragFrom: "emproducts",
            dragDataItem: dataItem
        });
    }

    rowForEmProducts = (row, props) => {

        const canStartDrag = ((props.dataItem as TreeItem).subItems || []).length == 0;

        return <RowRender props={props} row={row} onDragStart={this.handleDragStartFirst}
            canStartDrag={canStartDrag}
            dropEffect="none"
        />
    }

    rowForProducts = (row, props) => {
        //console.log('rowForProducts', row, props);
        const canStartDrag = true; //((props.dataItem as TreeItem).subItems || []).length > 0;
        const sameHierarchy = isSameHierarchy(this.state.dragDataItemLevel, this.state.draggedOverItemLevel);
        const isSameParent = this.state.dragDataItem && this.state.draggedOverItem &&
            (this.state.dragDataItem.ParentId == this.state.draggedOverItem.Id);


        const dropEffect = (this.state.dragDataItem && this.state.dragFrom)
            ? (this.state.dragFrom == 'emproducts'
                ? 'copy'
                : ((sameHierarchy || isSameParent) ? 'none' : 'move'))
            : 'none';

        return <RowRender props={props} row={row} onDragStart={(e, dataItem: TreeItem) => {
            //console.log();
            this.setState({
                dragFrom: "products",
                dragDataItem: dataItem,
                dragDataItemLevel: [...props.level]
            })
        }}
            onDrop={this.handleOnDropSecond}
            onDragOver={(e) => {
                if (this.state.draggedOverItem != props.dataItem) {
                    this.setState({
                        draggedOverItem: props.dataItem,
                        draggedOverItemLevel: [...props.level]
                    });
                }
            }}
            canStartDrag={canStartDrag}
            dropEffect={dropEffect}
        />
    }

    handleOnDropSecond = async (e) => {

        const draggedOverItem = this.state.draggedOverItem;
        const dragDataItem = this.state.dragDataItem;

        //console.log('drop second', draggedOverItem, dragDataItem);

        if (!draggedOverItem || !dragDataItem)
            return;

        if (this.state.dragFrom == 'emproducts') {

            var newProduct: Product = {
                Description: dragDataItem.Name,
                ProductId: uuidv4(),
                EmProductId: dragDataItem.Id,
                ParentProductId: draggedOverItem.Id
            }

            const saveResult = await ProductService.add(newProduct);

            if (!saveResult.hasErrors) {
                draggedOverItem.subItems = draggedOverItem.subItems || [];
                const dataItem = TreeItem.fromProduct(newProduct);

                this.setState({
                    items: modifySubItems(this.state.items, subItemsField,
                        (item: TreeItem) => item.Id === draggedOverItem.Id,
                        subItems => [dataItem, ...subItems]
                    ),
                    dragDataItem: undefined,
                    draggedOverItem: undefined,
                    dragFrom: undefined,
                    sortOnRecalc: true
                }, this.recalcFilteredItems);
            }

        }

        
        if (this.state.dragFrom == 'products') {

            const sameHierarchy = isSameHierarchy(this.state.dragDataItemLevel, this.state.draggedOverItemLevel);

            if ((dragDataItem.ParentId != draggedOverItem.Id) && !sameHierarchy) {

                var originalParentId = dragDataItem.ParentId;
                var productToSave = dragDataItem.dataItem as Product;
                productToSave.ParentProductId = draggedOverItem.Id;
              
                const saveResult = await ProductService.update(productToSave);
                              
                var updatedItems = moveTreeItem(this.state.items, this.state.dragDataItemLevel, this.state.draggedOverItemLevel, subItemsField);

                const ensureParentId = (item: TreeItem, parentId: string) => {
                    item.ParentId = parentId;
                    item.subItems = (item.subItems || []).map(x => ensureParentId(x, item.Id));
                    return item;
                };

                updatedItems = updatedItems.map(x => ensureParentId(x, undefined));

                if (!saveResult.hasErrors) {
                    this.setState({
                        items: updatedItems,
                        sortOnRecalc: true
                    }, this.recalcFilteredItems);
                }
            }
        }
    }   

    /*EmCell = (props: TreeListCellProps) => {
        return <td>{((props.dataItem as TreeItem).subItems || []).length == 0 && <span className="k-icon k-i-reorder"></span>} {props.dataItem[props.field]}</td>
    }*/

    ColumnEmProductName = (props: TreeListCellProps) => (<TreeListCellDragable {...props} useReorderIcon={(props.dataItem[subItemsField] || []).length == 0} />)

    ColumnProductName = (props: TreeListCellProps) => (<TreeListCellDragable {...props} useReorderIcon={true} />)

    render() {

        return (
            <Container fluid={true}>
                <Row>
                    <Col lg={6}>
                        <h3>Original Products</h3>
                        <TreeList
                            className="table-body-scroll"
                            data={this.state.filteredEmItems}
                            columns={[{ field: 'Name', title: 'Division / Product', filter: TreeListTextFilter, expandable: true, cell: this.ColumnEmProductName}]}
                            onRowClick={(e) => {
                                this.setState({
                                    selectedEmId: (e.dataItem as TreeItem).Id,
                                    selectedEmItem: (e.dataItem as TreeItem),
                                    selectedEmFullName: this.buildFullName((e.dataItem as TreeItem))
                                }, () => { this.recalcFilteredEmItems(); });
                            }}
                            selectedField={selectedField}
                            expandField={expandField}
                            filter={this.state.emFilter}
                            subItemsField={subItemsField}
                            onExpandChange={(e) => {
                                this.setState({
                                    expandedEmIds: e.value ?
                                        this.state.expandedEmIds.filter(id => id != (e.dataItem as TreeItem).Id) :
                                        [...this.state.expandedEmIds, (e.dataItem as TreeItem).Id]
                                }, this.recalcFilteredEmItems);
                            }}
                            onFilterChange={(event) => {
                                this.setState({
                                    emFilter: event.filter
                                }, this.recalcFilteredEmItems)
                            }}
                            rowRender={this.rowForEmProducts}
                        >
                        </TreeList>
                    </Col>
                    <Col lg={6}>
                        <h3>Custom Products</h3>
                        <TreeList
                            className="xtable-body-scroll"
                            data={this.state.filteredItems}
                            columns={[
                                { field: 'Name', title: 'Product', filter: TreeListTextFilter, expandable: true, width: 360, editCell: TreeListTextEditor, cell: this.ColumnProductName },
                                { title: 'Actions', cell: this.CommandCell, width: 260 }
                            ]}

                            editField={editField}
                            expandField={expandField}
                            subItemsField={subItemsField}
                            onItemChange={(event) => {
                                this.setState({
                                    items: mapTree(
                                        this.state.items,
                                        subItemsField,
                                        (item: TreeItem) => {
                                            if (item.Id === event.dataItem.Id) {
                                                return extendDataItem(item, subItemsField, { [event.field]: event.value })
                                            } else {
                                                return item
                                            }
                                        }
                                    )
                                }, this.recalcFilteredItems)
                            }}
                            onExpandChange={(e) => {
                                this.setState({
                                    expandedIds: e.value ?
                                        this.state.expandedIds.filter(id => id != (e.dataItem as TreeItem).Id) :
                                        [...this.state.expandedIds, (e.dataItem as TreeItem).Id]
                                }, this.recalcFilteredItems);
                            }}
                            filter={this.state.filter}
                            onFilterChange={(event) => {
                                this.setState({
                                    filter: event.filter
                                }, this.recalcFilteredItems)
                            }}
                            sort={this.state.itemsSort}
                            rowRender={this.rowForProducts}
                            toolbar={
                                <TreeListToolbar>
                                    <button
                                        title="Add new"
                                        className="k-button k-primary"
                                        onClick={this.addItem}
                                    >
                                        Add new
                                    </button>
                                </TreeListToolbar>
                            }
                        >
                        </TreeList>
                        {/*this.state.dragDataItem && <p>
                            dragDataItem: {this.state.dragDataItem.Name} / parent: {this.state.dragDataItem.ParentId} <br />
                            dragDataItemLevel: {(this.state.dragDataItemLevel || []).map(x => <span>{x},</span>)}
                        </p>}
                        {this.state.draggedOverItem && <p>
                            draggedOverItem: {this.state.draggedOverItem.Name} / parent: {this.state.dragDataItem.ParentId} <br />
                            draggedOverItemLevel: {(this.state.draggedOverItemLevel || []).map(x => <span>{x},</span>)}
                        </p>*/}

                    </Col>
                </Row>
                {this.state.dialogConfirmDeleteVisible &&
                    <Dialog title={"Please confirm"} onClose={() => this.cancelConfirmDeleteDialog()}>
                        <p style={{ margin: "25px", textAlign: "center" }}>Remove item <b>{this.state.itemToDelete.Name}</b>?</p>
                        <DialogActionsBar>
                            <button className="k-button" onClick={() => this.cancelConfirmDeleteDialog()}>No</button>
                            <button className="k-button" onClick={() => this.removeExecute(this.state.itemToDelete)}>Yes</button>
                        </DialogActionsBar>
                    </Dialog>}

            </Container>
        );
    }
}

class TreeItem {
    Id: string;
    Name: string;
    ParentId?: string;
    type: 'division' | 'emproduct' | 'product';
    subItems: TreeItem[];
    dataItem: any;
    parentDataItem: TreeItem;
    expanded: boolean;
    inEdit: boolean;
    isNew: boolean;
    isSaving?: boolean;

    public static fromDivision(item: Division, products: EmProduct[]): TreeItem {

        const result: TreeItem = {
            dataItem: item,
            parentDataItem: undefined,
            type: 'division',
            subItems: undefined,
            Name: item.Name,
            Id: item.Id,
            ParentId: undefined,
            expanded: false,
            inEdit: false,
            isNew: false
        };

        let subitems = products.filter(x => x.DivisionId == item.Id && x.ParentEmersonId == null).map(x => TreeItem.fromEmProduct(x, item.Id, products, result));
        if (subitems.length == 0)
            subitems = products.filter(x => x.DivisionId == item.Id && x.ParentEmersonId == '0').map(x => TreeItem.fromEmProduct(x, item.Id, products, result));

        result.subItems = subitems.sort(SortTreeItem);

        return result;
    }

    public static fromEmProduct(item: EmProduct, parentId: string, products: EmProduct[], parentDataItem: TreeItem): TreeItem {

        const result: TreeItem = {
            dataItem: item,
            type: 'emproduct',
            subItems: undefined,
            Name: item.Description,
            Id: item.Id,
            ParentId: parentId,
            parentDataItem: parentDataItem,
            expanded: false,
            inEdit: false,
            isNew: false
        };

        result.subItems = products.filter(x => x.ParentEmersonId == item.EmersonId)
            .map(x => TreeItem.fromEmProduct(x, item.Id, products, result))
            .sort(SortTreeItem);

        return result;
    }

    public static fromProduct(item: Product) {

        const result: TreeItem = {
            dataItem: item,
            type: 'product',
            subItems: undefined,
            Name: item.Description,
            Id: item.ProductId,
            ParentId: item.ParentProductId,
            parentDataItem: undefined,
            expanded: false,
            inEdit: false,
            isNew: false
        };

        return result;
    }

    public static bindDescriptionToDataItem(item: TreeItem) {

        if (item.type == 'product') {
            (item.dataItem as Product).Description = item.Name;
        }

        return item;
    }

    public static bindDataItemToDescription(item: TreeItem) {

        if (item.type == 'product') {
            item.Name = (item.dataItem as Product).Description;
        }

        return item;
    }

}

type TreeListCellDragableProps = TreeListCellProps & { useReorderIcon?: boolean };

class TreeListCellDragable extends React.Component<TreeListCellDragableProps> {
    /**
     * @hidden
     */
    render() {
        const { hasChildren, level = [0], expanded, dataItem, format } = this.props;
        const data = getNestedValue(this.props.field, dataItem);
        let dataAsString = '';

        if (data !== undefined && data !== null) {
            dataAsString = format ?
                provideIntlService(this).format(format, data) :
                data.toString();
        }

        const icons: Array<any> = [];
        if (this.props.expandable) {
            icons.push(...level.slice(1).map((_x, i) => (<span className="k-icon k-i-none" key={i} />)));
            if (hasChildren) {
                icons.push(
                    <span
                        className={`k-icon k-i-${expanded ? 'collapse' : 'expand'}`}
                        key="expand-collapse"
                        onClick={event => this.props.onExpandChange(event, dataItem, level)}
                    />
                );

                if (this.props.useReorderIcon)
                    icons.push(<span className="k-icon k-i-reorder mr-1" style={{ marginTop: '-3px' }} key={icons.length} />);

            } else {

                icons.push(<span className="k-icon k-i-none" key={icons.length} />);                

                if (this.props.useReorderIcon)
                    icons.push(<span className="k-icon k-i-reorder mr-1" style={{ marginTop: '-3px' }} key={icons.length} />);
            }
        }

        const defaultRendering = (
            <td
                style={this.props.style}
                className={classNames(this.props.className, {
                    ['k-text-nowrap']: this.props.expandable
                })}
                colSpan={this.props.colSpan}
            >
                {icons}
                {dataAsString}
            </td>
        );

        return this.props.render ?
            this.props.render.call(undefined, defaultRendering, this.props) :
            defaultRendering;
    }
}

function isSameHierarchy(arr1: number[], arr2: number[]): boolean {

    if (!arr1 || !arr2)
        return false;

    const arr1Length = arr1.length;
    const arr2Length = arr2.length;    

    if (arr1Length > arr2Length)
        return false;

    let allMatch = true;

    for (var i = 0; i < arr1Length && i < arr2Length; i++) {

        if (arr1[i] != arr2[i]) {
            allMatch = false;
        }
    }

    return allMatch;
}

export function getNestedValue(fieldName: string | undefined, dataItem: any): any {
    const path = (fieldName || '').split('.');
    let data = dataItem;
    path.forEach((p) => {
        data = data ? data[p] : undefined;
    });

    return data;
}


const SortTreeItem = (a: TreeItem, b: TreeItem) => {

    if (a.Name > b.Name)
        return 1;

    if (a.Name < b.Name)
        return -1;

    return 0;
}

const GenericSort = (propName: string) => {

    return (a: any, b: any) => {

        if (a[propName] > b[propName])
            return 1;

        if (a[propName] < b[propName])
            return -1;

        return 0;
    }
}

export default ProductBuilder;

function ProductItemCommandCell(enterEdit, remove, save, cancel, addChild, editField) {
    return class extends TreeListCell {
        render() {
            const { dataItem } = this.props;

            const hasSubitems = ((dataItem as TreeItem).subItems || []).length > 0;

            if (dataItem[saveField] == true)
                return <td>saving...</td>

            return dataItem[editField]
                ? (
                    <td>
                        <button
                            className="k-button"
                            onClick={() => save(dataItem)}>
                            {dataItem.isNew
                                ? 'Add'
                                : 'Update'}
                        </button>
                        <button
                            className="k-button"
                            onClick={() => cancel(dataItem)}>{dataItem.isNew
                                ? 'Discard'
                                : 'Cancel'}
                        </button>
                    </td>
                ) : (
                    <td>
                        <button
                            className="k-button"
                            onClick={() => addChild(dataItem)}>
                            Add Child
                        </button>
                        <button
                            className="k-button"
                            onClick={() => enterEdit(dataItem)}>
                            Edit
                        </button>
                        {!hasSubitems &&
                            <button
                                className="k-button"
                                onClick={() => remove(dataItem)}>
                                Remove
                            </button>
                        }
                    </td>
                );
        }
    }
}

const traverseTree = (data: any[], subItemsField: string): any[] => {
    return data;
}